import { Injectable } from "@angular/core";
import { RepositoryUrlService } from "../repository-url/repository-url.service";

@Injectable()
export class CommitsUrlService {
  // GitHub and GitLab use the same commits path.
  private DEFAULT_COMMITS_PATH = "/commits/master/";
  private BITBUCKET_COMMITS_PATH = "/history-node/master/";

  constructor(private repositoryUrlService: RepositoryUrlService) {}

  public urlFor(project: any, file: string) {
    const repoUrl = this.repositoryUrlService.findForProject(project);
    let commitsPath = "";

    if (repoUrl.indexOf("bitbucket") > -1) {
      commitsPath = this.BITBUCKET_COMMITS_PATH;
    } else {
      commitsPath = this.DEFAULT_COMMITS_PATH;
    }

    return repoUrl + commitsPath + file;
  }
}
